import CTAs from "./CTAs";

const WelcomeScreen = ({ onClose }) => {
  return (
    <>
      <style>{`
        .dd-card {
          background: #ffffff; border: 1px solid #E2E8F0; border-radius: 16px;
          box-shadow: 0 1px 3px rgba(0,0,0,0.06), 0 2px 12px rgba(0,0,0,0.04);
          font-family: 'DM Sans', sans-serif;
        }
        .dd-section-label {
          font-size: 14px; font-weight: 700; color: #0F172A; margin: 0 0 12px;
        }
        .dd-text {
          font-size: 13px; color: #64748B; line-height: 1.6;
        }
        .dd-image-container {
          background: #F8FAFC;
          border-radius: 12px;
          padding: 32px 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 24px;
        }
      `}</style>

      <div
        className="dd-card"
        style={{
          width: "640px",
          maxWidth: "90vw",
          display: "flex",
          flexDirection: "column",
          padding: "28px 28px 24px",
          gap: 24,
        }}
      >
        {/* Logo / Image */}
        <div className="dd-image-container">
          <img
            src="assets/main-logo.svg"
            alt="Welcome"
            style={{ width: "280px", maxWidth: "100%", height: "auto" }}
          />
        </div>

        {/* Title and description */}
        <div>
          <h2
            className="dd-section-label"
            style={{ fontSize: 16, marginBottom: 12 }}
          >
            Welcome to 6EL∆
          </h2>
          <p className="dd-text" style={{ marginBottom: 8 }}>
            Thank you for joining 6EL∆ in its Beta launch phase - you’re among
            the first to experience a new way of managing credit control,
            invoicing, and business debt recovery.
          </p>
          <p className="dd-text" style={{ marginBottom: 8 }}>
            As one of our early users, your experience and insights are
            incredibly valuable. We’re continuously refining 6EL∆ to make it
            smarter, smoother, and more powerful for businesses like yours.
          </p>
          <p className="dd-text" style={{ marginBottom: 8 }}>
            If you encounter anything that feels unclear, could work better, or
            you have ideas for new features, our technical team would love to
            hear from you. Share your feedback anytime.
          </p>
          <p className="dd-text">
            Together, we’ll shape the future of intelligent debt management.
          </p>
        </div>

        {/* Buttons */}
        <div style={{ display: "flex", gap: 12, justifyContent: "flex-end" }}>
          <CTAs
            type="Secondarybtn"
            text="Skip"
            width="auto"
            onClick={onClose}
          />
          <CTAs
            type="Primarybtn"
            text="Continue"
            width="auto"
            onClick={onClose}
          />
        </div>
      </div>
    </>
  );
};

export default WelcomeScreen;
